import React from 'react';

import { Progress } from '@useblu/ocean-react';

import * as S from './styles';

const Loading: React.FC = () => {
  return (
    <S.Wrapper>
      <Progress size="lg" />
    </S.Wrapper>
  );
};

export default Loading;
